import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/Icon';
import Nav from '../components/home/Nav';
import Hero from '../components/home/Hero';
import PressStrip from '../components/home/PressStrip';
import Problem from '../components/home/Problem';
import Solution from '../components/home/Solution';
import HowItWorks from '../components/home/HowItWorks';
import StatesGrid from '../components/home/StatesGrid';
import BenefitsSplit from '../components/home/BenefitsSplit';
import SocialProof from '../components/home/SocialProof';
import LandingCTA from '../components/home/LandingCTA';
import FinalCTA from '../components/home/FinalCTA';
import Footer from '../components/home/Footer';
import { initMotion } from '../utils/motion';

function Home() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 16);
      setShowSticky(y > 700);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const cleanup = initMotion();
    return cleanup;
  }, []);

  const goToEligibility = () => {
    navigate('/eligibility');
  };

  return (
    <div>
      <Nav scrolled={scrolled} onCTA={goToEligibility} />

      <Hero onCTA={goToEligibility} showImagery={true} headlineStyle="deserve" ctaCopy="default" />

      <PressStrip />

      <Problem />
      <Solution onCTA={goToEligibility} />
      <HowItWorks onCTA={goToEligibility} />
      <StatesGrid onCTA={goToEligibility} />
      <BenefitsSplit onCTA={goToEligibility} />
      <SocialProof />
      <LandingCTA onCTA={goToEligibility} />
      <FinalCTA onCTA={goToEligibility} />
      <Footer />

      {/* Sticky scroll bar */}
      <div className={`scroll-bar ${showSticky ? 'visible' : ''}`}>
        <div className="scroll-bar-text">
          <strong>You may qualify for $2,000–$4,000/month.</strong>{' '}
          <span style={{ color: 'var(--ink-mute)' }}>Find out in 2 minutes.</span>
        </div>
        <button className="btn btn-primary btn-sm" onClick={goToEligibility}
                style={{ height: 48, padding: '0 20px', fontSize: 15 }}>
          Check Your Eligibility
          <Icon name="arrow-right" size={14} stroke={2.4} className="arrow" />
        </button>
      </div>
    </div>
  );
}

export default Home;
